import React from 'react';
import { Create, FormTab, TabbedForm } from 'react-admin';

import * as AccessCheck from '../../../Common/Utils/AccessCheck';
import ProperyGroupTitleName from './StaticData/TitleName';
import PropertiesTab from './Partials/PropertiesTab';
import PermissionToolbar from '../../../Common/Toolbar';
import RequiredRole from './StaticData/RequiredRole';
import SettingsTab from './Partials/SettingsTab';
import Title from '../../../Common/Title';

type Props = {
  basePath: string,
  permissions: any,
  record: any,
  resource: string
};

const ProperyGroupCreate = (props: Props) => (
  <Create title={<Title title={ProperyGroupTitleName} record={props.record} />} {...props}>
    <TabbedForm toolbar={<PermissionToolbar accessCheck={AccessCheck.Edit(props.permissions, RequiredRole)} basePath={props.basePath} record={props.record} resource={props.resource} />} redirect="edit">
      <FormTab label="Settings">
        <SettingsTab record={props.record} />
      </FormTab>
      <FormTab label="Properties">
        <PropertiesTab record={props.record} />
      </FormTab>
    </TabbedForm>
  </Create>
);

export default ProperyGroupCreate;



// WEBPACK FOOTER //
// ./src/views/Components/Managed/PropertyGroups/Create.tsx